var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ops-section" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "ops-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("排行榜设置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-row",
                { staticClass: "rank-settings", attrs: { gutter: 32 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "left", attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活跃榜.背景图" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "background-uploader",
                              attrs: {
                                action: "#",
                                "list-type": "picture-card",
                                limit: 1,
                                "auto-upload": false,
                                "on-exceed": _vm.onExceed,
                                "file-list": _vm.form.activeBgList,
                                "on-preview": _vm.handlePictureCardPreview,
                                "on-remove": _vm.handleActiveBgRemove,
                                "on-change": _vm.handleActiveBgChange,
                                "before-upload": _vm.beforeUpload,
                                accept: "image/*",
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip",
                                },
                                [
                                  _vm._v(
                                    "\n                建议尺寸：750×750，jpg/png，且不超过2MB\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "人气榜.背景图" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "background-uploader",
                              attrs: {
                                action: "#",
                                "list-type": "picture-card",
                                limit: 1,
                                "auto-upload": false,
                                "on-exceed": _vm.onExceed,
                                "file-list": _vm.form.popularBgList,
                                "on-preview": _vm.handlePictureCardPreview,
                                "on-remove": _vm.handlePopularBgRemove,
                                "on-change": _vm.handlePopularBgChange,
                                "before-upload": _vm.beforeUpload,
                                accept: "image/*",
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip",
                                },
                                [
                                  _vm._v(
                                    "\n                建议尺寸：750×750，jpg/png，且不超过2MB\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "right", attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排行榜.积分奖励" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "600px" },
                                  attrs: {
                                    data: _vm.form.rankRewards,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "名次", width: "120" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              "\n                    第" +
                                                _vm._s(scope.$index + 1) +
                                                "名\n                  "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "奖励积分" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              staticStyle: { width: "120px" },
                                              attrs: {
                                                size: "small",
                                                type: "number",
                                                min: "0",
                                              },
                                              model: {
                                                value: scope.row.points,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "points",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "scope.row.points",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      width: "100",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm.form.rankRewards.length > 1
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeRank(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "add-rank",
                                  on: { click: _vm.addRank },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-plus",
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("添加名次")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { "label-width": "0" } }, [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c("el-button", { on: { click: _vm.onReset } }, [
                      _vm._v("重置"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onConfirm },
                      },
                      [_vm._v("确认")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, size: "tiny" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }